import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

interface SubtaskItemCustomerRejectDialogProps {
  open: boolean;
  onClose: (reason: string) => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    customInput: {
      '& .MuiOutlinedInput-adornedStart': {
        paddingLeft: '8px', // ปรับ padding-left เป็น 8px
      },
      '& .MuiOutlinedInput-root': {
        transition: 'box-shadow 0.3s ease-in-out',
        '& fieldset': {
          borderWidth: '1px', // กำหนดขนาดเส้นขอบเป็น 1px
        },
        '&:hover fieldset': {
          borderWidth: '1px', // ให้ขนาดขอบคงที่ตอน hover
          borderColor: '#1565c0', // เปลี่ยนสีขอบให้เข้ากับเงา
        },
        '&.Mui-focused fieldset': {
          borderWidth: '1px', // ให้ขนาดขอบคงที่ตอน focus
          borderColor: '#1565c0', // เปลี่ยนสีขอบให้เข้ากับเงา
        },
        '&.Mui-focused': {
          boxShadow: '0 0 8px rgba(33, 150, 243, 0.6)', // สีฟุ้งตอน focus
          backgroundColor: '#fafafa',
        },
      },
      marginTop: '4px',
      marginBottom: '8px',
    },
  }),
);

const SubtaskItemCustomerRejectDialog = (props: SubtaskItemCustomerRejectDialogProps) => {
  const { open, onClose } = props;

  const classes = useStyles();
  const [reason, setReason] = useState<string>('');

  useEffect(() => {
    if (!open) {
      setReason('');
    }
  }, [open]);

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Customer Reject Item</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Reason</Typography>
        <TextField
          className={classes.customInput}
          type="input"
          variant="outlined"
          name="reason"
          placeholder="Please enter reason for customer reject"
          fullWidth
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
          }}
          //   error={!!errors.description}
          //   helperText={errors.description}
          size="small"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={() => onClose('')}>
          Close
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!reason}
          onClick={() => onClose(reason)}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubtaskItemCustomerRejectDialog;
